import _ from 'lodash';

import { validatePatient } from 'common-src/models/Patient';
import { validatePatientPhoneNumber } from 'common-src/models/PatientPhoneNumber';

import { initialState } from './constants';

export const getIsButtonEnabled = (data, errors) => {
  if (_.isEqual(data, initialState) || Object.values(errors).some((e) => e)) return false;
  return true;
};

export const getErrorMessage = (field, newValue) => {
  switch (field) {
    case 'phoneNumber': {
      return validatePatientPhoneNumber(field, newValue);
    }
    case 'initialFlow': {
      return { [field]: !newValue ? 'Please select patient type' : '' };
    }
    default: {
      return validatePatient(field, newValue);
    }
  }
};

export const catchErrors = (data) => {
  const errors = {};
  Object.entries(data).forEach(([field, value]) => {
    const err = getErrorMessage(field, value);
    if (err[field]) {
      Object.assign(errors, { [field]: err[field] });
    }

    if (field === 'address') {
      Object.entries(value).forEach(([subField, subValue]) => {
        const addressField = `address.${subField}`;
        const err = getErrorMessage(addressField, subValue);
        if (err[addressField]) {
          Object.assign(errors, { [addressField]: err[addressField] });
        }
      });
    }
  });

  return {
    errors,
    hasErrors: !_.isEmpty(errors) || Object.values(errors).some((e) => e),
  };
};
